import { Button } from '@mui/material';
import { FC } from 'react';

interface AzureLoginButtonProps {
  onClick: () => void;
}

export const AzureLoginButton: FC<AzureLoginButtonProps> = ({ onClick }) => (
  <Button
    onClick={onClick}
    variant="outlined"
    startIcon={
      <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
        <path fill="#F25022" d="M0 0h8.5v8.5H0z" />
        <path fill="#7FBA00" d="M9.5 0H18v8.5H9.5z" />
        <path fill="#00A4EF" d="M0 9.5h8.5V18H0z" />
        <path fill="#FFB900" d="M9.5 9.5H18V18H9.5z" />
      </svg>
    }
    sx={{ textTransform: 'none', width: 280 }}
  >
    Login V-Collection
  </Button>
);
